import React, { Component } from 'react';
import Select from "react-select";
import { Input } from "reactstrap";
import { Modal, message, Switch } from 'antd';
import axios from "axios";

class EditMaterialModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false,
            materialOptions: [],
            valueToChange: this.getValueToChange(props.materialToEdit)
        };
        this.handleOk = this.handleOk.bind(this);
        this.getMaterialOptions = this.getMaterialOptions.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.editMaterialValue = this.editMaterialValue.bind(this);
        this.extractValues = this.extractValues.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.handleChangeBoolean = this.handleChangeBoolean.bind(this);
        this.getValueToChange = this.getValueToChange.bind(this);
        this.handleChangeNumber = this.handleChangeNumber.bind(this);
        this.getMaterialOptions({ appointment_id: props.appointmentType, material_uuid: props.materialToEdit.material_type.uuid });
    }
    getValueToChange = (materialToEdit) => {
        const { material_type, material_options, number_value, boolean_value, string_value } = materialToEdit;
        const type = material_type.type;
        switch (type) {
            case "single":
            case "multiple":
                return material_options.map((option) => ({ value: option.id, label: option.name }));
            case "number":
                return number_value;
            case "boolean":
                return boolean_value;
            default:
                return string_value;
        }
    };
    handleOk = () => {
        this.editMaterialValue();
    };
    handleCancel = () => {
        this.props.handleOpenMaterialModal(false);
    };
    extractValues = (materialOptions) => {
        if (Array.isArray(materialOptions)) {
            return materialOptions.map(option => option.value);
        } else if (materialOptions && typeof materialOptions === 'object') {
            return materialOptions.value;
        }
        return null;
    };
    getMaterialOptions = async ({ appointment_id, material_uuid }) => {
        try {
            if (appointment_id && material_uuid) {
                const res = await axios.post(
                    `https://backoffice.nadu.xyz/api/material-option/getMaterialOptions/`, {//https://backoffice.nadu.xyz
                    appointment_id: appointment_id,
                    material_uuid: material_uuid
                }
                );
                if (res.data && res.data.length > 0) {
                    let formattedData = res.data.map((opcion) => ({
                        value: opcion.id,
                        label: opcion.name
                    }))
                    this.setState({ materialOptions: formattedData })
                }
            }
        } catch (error) {
            console.log(error)
        }
    };
    editMaterialValue = async () => {//https://backoffice.nadu.xyz
        this.setState({ confirmLoading: true });
        try {
            const materialToEdit = this.props.materialToEdit;
            const valueToChange = this.state.valueToChange;
            let data;
            switch (materialToEdit.material_type.type) {
                case "multiple":
                case "single":
                    data = { material_options: this.extractValues(valueToChange) };
                    break;
                case "text":
                    data = { string_value: valueToChange };
                    break;
                case "number":
                    data = { number_value: valueToChange };
                    break;
                case "boolean":
                    data = { boolean_value: valueToChange };
                    break;
                default:
                    data = { string_value: valueToChange };
                    break;
            }
            const res = await axios.put(
                `https://backoffice.nadu.xyz/api/materials/${materialToEdit.id}`,
                { data: data }
            );
            if (res.status >= 200 && res.status <= 299) {
                this.props.getMaterialsByAppointment(materialToEdit.appointment_uuid)
                message.success('Se ha editado el material');
            } else {
                message.error("Error: No se ha podido modificar el material.");
                console.log("Error: ", res)
            }
        } catch (error) {
            message.error("Error: No se ha podido modificar el material.");
            console.log("Error: ", error)
        }
        this.setState({ confirmLoading: false });
        this.props.handleOpenMaterialModal(false);
    };
    handleChangeBoolean = (checked) => {
        this.setState({ valueToChange: checked });
    };
    handleChangeNumber = (event) => {
        const value = event.target.value;
        let validatedValue = value.replace(/[^\d]/g, "");
        this.setState({ valueToChange: validatedValue });

    };
    renderForm = () => {
        const { materialToEdit, confirmLoading } = this.props;
        const { material_type: { type } } = materialToEdit;
        switch (type) {
            case "text":
                return (
                    <Input
                        type="text"
                        value={this.state.valueToChange}
                        onChange={(event) => this.setState({ valueToChange: event.target.value })}
                        style={{ height: "100%" }}
                    />
                );
            case "multiple":
            case "single":
                return (
                    <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        placeholder="Seleccionar valor"
                        name="optionalMaterial_types"
                        isMulti={type === "multiple"}
                        isDisabled={confirmLoading}
                        value={this.state.valueToChange}
                        options={this.state.materialOptions}
                        noOptionsMessage={() => "Cargando opciones"}
                        onChange={(value) => this.setState({ valueToChange: value })}
                    />
                );
            case "boolean":
                return (
                    <Switch
                        checked={this.state.valueToChange}
                        onChange={this.handleChangeBoolean}
                    />
                );
            case "number":
                return (
                    <Input
                        type="text"
                        value={this.state.valueToChange}
                        onChange={(event) => this.handleChangeNumber(event)}
                        style={{ height: "100%" }}
                    />
                );
            default:
                return "No tiene tipo de material";
        }
    }
    render() {
        const { openMaterialModal, materialToEdit } = this.props;
        const { confirmLoading } = this.state;
        return (
            <Modal
                title={"Editando " + materialToEdit.material_type.name}
                open={openMaterialModal}
                onOk={this.handleOk}
                centered={true}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
            >
                {this.renderForm()}
            </Modal>
        );
    }
}

export default EditMaterialModal;



// WEBPACK FOOTER //
// ./src/views/HomeVisits/EditMaterialModal.jsx